/**
 * Reset password reducers index script file
 *
 * @package    Reducers
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import Immutable from 'seamless-immutable';

import {
    RESET_PASSWORD_REQUEST,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_ERROR, CHECK_RESET_PASSWORD_TOKEN_SUCCESS,
} from 'Actions/auth';

export const INITIAL_STATE = Immutable({
    loading: false,
    success: false,
    error: false,
    isValidToken: false
});

export default function resetPasswordReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case RESET_PASSWORD_REQUEST:
            return state.merge({
                loading: true,
                success: false,
                error: false,
            });

        case RESET_PASSWORD_SUCCESS:
            return state.merge({
                loading: false,
                success: true,
                error: false
            });

        case RESET_PASSWORD_ERROR:
            return state.merge({
                loading: false,
                success: false,
                error: true
            });

        case CHECK_RESET_PASSWORD_TOKEN_SUCCESS:
            return state.merge({
                isValidToken: action.payload.data,
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/resetPasswordReducer.js